<template>
  <v-text-field
    v-bind="$attrs"
    :value="value"
    autocomplete="nope"
    v-on="inputListeners" />
</template>
<script>

function completeDateString(dateString, ignoreYear, alwaysCompleteYear) {

  // 1. remove invalid chars
  dateString = dateString.replace(/[^0-9.\b]/g, '');
  dateString = dateString.replace(/[.]{2,}/g, '.');
  dateString = dateString.replace(/^[.]+}/g, '');

  // 2. autocomplete leading zeros if dots were entered
  if (dateString.charAt(1) === '.' && dateString.charAt(0) !== '0') {
    dateString = '0' + dateString;
  }
  if (dateString.charAt(4) === '.' && dateString.charAt(3) !== '0') {
    dateString = dateString.slice(0, 3) + '0' + dateString.slice(3, dateString.length);
  }
  // 3. split into day month year and complete values
  let [d, m, y] = dateString.split('.', 3);
  if (d) {
    // autocomplete leading zero
    if (3 < +d.charAt(0)) {
      d = '0' + d;
    }
    //remove overflow
    if (d.length > 2) {
      m = d.slice(2, d.length) + (m ? m : '');
      d = d.slice(0, 2);
    }
    if (d.length === 2) {
      d += '.';
    }
  }
  if (m) {
    // autocomplete leading zero
    if (1 < +m.charAt(0)) {
      m = '0' + m;
    }
    // remove overflow
    if (m.length > 2) {
      y = m.slice(2, m.length) + (y ? y : '');
      m = m.slice(0, 2);
    }
    if (m.length === 2) {
      m += '.';
    }
  }
  if (y && !ignoreYear) {
    // autocomplete leading '19' or '20' for input DDMMYY
    // complete "19" and "20" to "2019" / "2020" only if alwaysCompleteYear is set
    if (y.length === 2 &&
      (alwaysCompleteYear || (y !== '19' && y !== '20'))) {
      y = +y < 30 ? '20' + y : '19' + y;
    }
    //remove overflow
    if (y.length > 4) {
      y = y.slice(0, 4);
    }
  }
  // 4. combine day, month, year
  let fullDate = d ? d : '';
  fullDate += fullDate && m ? m : '';
  fullDate += fullDate && y && !ignoreYear ? y : '';

  return fullDate;
}

export default {
  name: "DateField",
  props: {
    'value': {
      type: String,
      default: ''
    },
    'noYear': {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      prevInput: this.value ? this.value : ""
    };
  },
  computed: {
    inputListeners: function () {
      const vm = this;
      return Object.assign({},
        this.$listeners,
        {
          input: function (data) {
            let input = vm.$children[0].$refs.input;

            // no autocompletion on delete
            const backspace = vm.value.length > data.length;
            if (backspace) {
              vm.prevInput = data;
              vm.value = data;
              vm.$emit('input', data);
              return;
            }

            const fullDate = completeDateString(data, vm.noYear, false);
            const newCursor = input.selectionEnd - data.length + fullDate.length;

            /*reset binding data for input field and update it in $nextTick
              => if formatting removed the input, value doesn't change => DOM update is not triggered */
            //vm.prevInput = ' ';
            // communicate formatted input to parent component (v-model)
            vm.$emit('input', fullDate);
            vm.$nextTick(() => {
              // set cursor to correct position after autocompletion
              input.selectionStart = newCursor;
              input.selectionEnd = newCursor;
              vm.value = fullDate;
              vm.prevInput = fullDate;
            });
          },
          blur: function (event) {
            const fullDate = completeDateString(event.srcElement.value, vm.noYear, true);
            vm.prevInput = fullDate;
            vm.value = fullDate;
            // communicate formatted input to parent component (v-model)
            vm.$emit('input', fullDate);
          }
        }
      );
    }
  }
};
</script>
<style>

</style>
